import { useEffect, useState } from "react";

import { db } from "../firebase/config";

const useFakeView = () => {
  const [fakeView, setFakeView] = useState(0);

  useEffect(() => {
    db.collection("meta")
      .doc("fakeView")
      .onSnapshot(async (qs) => {
        const data = qs.data();

        if (data?.view) {
          setFakeView(data.view);
        }
      });
  }, []);

  return fakeView;
};

export default useFakeView;
